import Vue from 'vue'
import App from './App'
import router from './router'
//Adicionales al default del proyecto
import VueMaterial from 'vue-material'
import VueResource from 'vue-resource'
import VueSession from 'vue-session'
import VueMask from 'v-mask';
import 'vue-material/dist/vue-material.min.css'
Vue.use(VueSession, {
  persist: true
})
Vue.use(VueResource)
Vue.use(VueMaterial)
Vue.use(VueMask)

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

//Vue.http.options.root = 'http://localhost/cfosc/api/';
Vue.http.options.root = 'http://api.fortalecimiento.org/';

Vue.http.options.emulateJSON = true;
Vue.config.productionTip = false
//Montamos el app
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')